export const introduce = {
  title: {
    KR: "회사소개",
    EN: "About US",
  },
  info: {
    title: {
      KR: "루미르 주식회사  <span>Lumir Inc.</span>",
      EN: "Lumir Inc.",
    },
    content: {
      KR: "지구관측 인공위성 전문기업",
      EN: "Lumir has been a key partner in Korea’s space industry, contributing to major milestones and shaping the New Space era with innovative Earth observation technologies. We’re creating a connected, sustainable world by providing continuous, actionable intelligence for businesses and governments.",
    },
    KR: [
      {
        title: "주소",
        content:
          "경기도 용인시 수지구 신수로 767,<br/> 분당수지 U-TOWER A동 1103호",
      },
      {
        title: "기업형태",
        content: "코스닥 상장 (474170)<br/>2024년 10월 21일",
      },
      {
        title: "대표이사",
        content: "남명용",
      },
      { title: "설립일", content: "2009년 11월 2일" },
      { title: "직원수", content: "80명 +" },
      { title: "업종", content: "항공기용 부품 제조업" },
      {
        title: "주요사업",
        content:
          "인공위성 시스템<br/>인공위성 탑재장치<br/>위성기반 정보 서비스",
      },
      { title: "정부 R&D 과제 수주 금액", content: "301억 +" },
      { title: "대한민국 인공위성 개발 수주", content: "28억 +" },
    ],
    EN: [
      {
        title: "Address",
        content:
          "1103, U-TOWER A, 767, Sinsu-ro, Suji-gu, Yongin-si, Gyeonggi-do",
      },
      {
        title: "Corporate Form",
        content: "Listed on KOSDAQ (474170)<br/>October 21, 2024",
      },
      {
        title: "CEO",
        content: "NAM Myeong-ryong",
      },
      { title: "Establishment Date", content: "November 2, 2009" },
      { title: "Number of Employees", content: "80 +" },
      { title: "Industry", content: "Manufacture of Aircraft Parts" },
      {
        title: "Main Business",
        content:
          "Satellite System<br/>Satellite Mounting Device<br/>Satellite-based Information Service",
      },
      {
        title: "Government R&D Project Contract Amount",
        content: "301 billion +",
      },
      {
        title: "Korea Satellite Development Contract",
        content: "28 billion +",
      },
    ],
  },
  philosophy: {
    title: {
      KR: "기업이념  <span>Corporate Philosophy</span>",
      EN: "Lumir's Corporate Philosophy",
    },
    KR: [
      {
        title: "기업미션",
        content:
          "우리는 고객, 주주, 임직원의 신뢰를 통해<br/>지속적으로 성장하여 <span>겨레</span>와 <span>나라</span>에 기여한다.",
      },
      {
        title: "기업비전",
        content:
          "인공위성 시장에서 <span>자체기술</span> 기반으로<br/>영상 제공 및 데이터 서비스를 제공하는 <span>글로벌 기업</span>",
      },
      {
        title: "핵심경영",
        content: [
          "<b>L</b>oyalty - 고객 충성 신뢰 바탕의 경영<br/><b>U</b>plift - 지속적인 기술 서비스 개선을 통한 성공<br/><b>M</b>ission-driven - 미션 중심 경영<br/><b>I</b>nnovation - 끊임없는 혁신을 통한 경쟁력 강화<br/><b>R</b>ule Respect - 합리적 원칙의 설정과 중시",
        ],
      },
      {
        title: "핵심가치",
        content: [
          "<p>Harmonia et Differentia</p>서로 <span>화합</span>하고 <span>조화</span>를 이루는 가운데 다른 생각을 가진<br/>개인의 독창성과 자유를 인정하고 포용하는 열린 기업",
        ],
      },
    ],
    EN: [
      {
        title: "Corporate Mission",
        content:
          "Advancing space innovation from Korea, Lumir strengthens national security, enhances disaster response and supports environmental monitoring, protecting Korea and its allies through cutting edge satellite technology.",
      },
      {
        title: "Corporate Vision",
        content:
          "Our vision is to shape a smarter, more connected world through space technology—establishing Lumir as a global leader in AI-driven Earth observation and driving Korea’s continued ascent in the New Space era.",
      },
      {
        title: "Core Management",
        content:
          "<b>L</b>oyalty<br/><b>U</b>plift<br/><b>M</b>ission-Driven<br/><b>I</b>nnovation<br/><b>R</b>ule Respect",
      },
      {
        title: "Core Values",
        content: [
          "<b>Harmonia et Differentia</b>",
          "Harmonia et Differentia: An open company that recognizes and embraces the originality and freedom of individuals with diverse thoughts, while fostering harmony and collaboration among them.",
        ],
      },
    ],
  },
  ceo: {
    title: {
      KR: "CEO 인사말  <span>CEO Greetings</span>",
    },
  },
  organization: {
    title: {
      KR: "회사조직 <span>Company Organizationt</span>",
      EN: "Company Organization",
    },
  },
  ci: {
    title: {
      KR: "CI <span>Corporate Identity</span>",
      EN: "Corporate Identity",
    },
    contents: {
      KR: {
        symbol: {
          title: "심벌마크",
          subTitle:
            "고구려의 자주성과 독립 정신의 상징 <span>삼족오</span>, 겨레와 나라를 위한 기술을 개발하는 기업 루미르",
          desc: [
            "날개를 활짝 핀 삼족오의 형상은 보다 크고 넓게 성장하는 기업의 비전을 상징합니다.",
            "미래 감성에 맞게 재해석되어 표현된 삼족오의 비주얼은 미래와 우주를 향한 루미르의 도약과 성장을 의미합니다.",
          ],
          img: "/assets/imgs/renewal/introduce/overview/삼족오.png",
        },
        colorSystem: {
          title: "컬러시스템",
          colors: [
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_blue.png",
              cmyk: "C100",
              rgb: "G160 / B233",
            },
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_purple.png",
              cmyk: "C70 / M100 / K10",
              rgb: "R101 / G18 / B126",
            },
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_black.png",
              cmyk: "K100",
              rgb: "RGB0",
            },
          ],
          desc: [
            "오로라 컬러의 태양, 우주, 지구는 신비한 미지의 공간을 개척하는 우주산업의 성장에 일조하는 루미르를 의미합니다.",
          ],
        },
      },
      EN: {
        symbol: {
          title: "Logo",
          subTitle:
            "The symbol is inspired by the independent spirit of the ancient Korean kingdom of Goguryeo which the <span>Samjoko</span> (the three-legged crow) represented.",
          desc: [
            "Lumir, a company dedicated to developing technology for Korea, its allies and its business customers, draws inspiration from this symbol.",
            "The shape of the Samjoko, with its wings spread wide, symbolizes the company’s vision of growth and expansion. The modern reinterpretation of the Samjoko signifies Lumir's flight from Earth toward the far reaches of outer space.",
          ],
          img: "/assets/imgs/renewal/introduce/overview/삼족오.png",
        },
        colorSystem: {
          title: "CI Color Code",
          colors: [
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_blue.png",
              cmyk: "C100",
              rgb: "G160 / B233",
            },
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_purple.png",
              cmyk: "C70 / M100 / K10",
              rgb: "R101 / G18 / B126",
            },
            {
              img: "/assets/imgs/renewal/introduce/overview/삼족오_black.png",
              cmyk: "K100",
              rgb: "RGB0",
            },
          ],
          desc: [
            "The aurora’s vibrant colors symbolize the harmony between Earth, the Sun, and space—blue for our planet, red for solar energy, and black for the vast unknown. This reflects Lumir’s pioneering spirit in space discovery and scientific innovation. We are committed to unlocking the mysteries of the unknown and driving the growth of the space industry.",
          ],
        },
      },
    },
  },
};
